/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SelectEnvironmentRequest = zod
	.object({
		environment_id: zod.uuid().describe('Environment ID to select')
	})
	.describe('Request body for selecting an environment');

export type SelectEnvironmentRequest = zod.input<typeof SelectEnvironmentRequest>;
export type SelectEnvironmentRequestOutput = zod.output<typeof SelectEnvironmentRequest>;
